function openCartDrawer() {
    document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
    document
        .querySelector(".cart-drawer")
        .classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
    document.querySelectorAll(".cart-count").forEach((el) => {
        el.textContent = count;
    });
}

async function updateCartDrawer() {
    const res = await fetch("/?section_id=cart-drawer");
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;

    const newBox = html.querySelector(".cart-drawer").innerHTML;


    document.querySelector(".cart-drawer").innerHTML = newBox;

    addCartDrawerListeners();
}

async function deleteCartItem(key) {
    // Send delete request to Shopify cart API
    const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: 0 } }), // Setting quantity to 0 removes the item
    });

    // Parse response
    const cart = await res.json();

    // Update cart count in UI
    updateCartItemCounts(cart.item_count);

    // Refresh the cart drawer
    await updateCartDrawer();
}


function addCartDrawerListeners() {
    // Update quantities
    document.querySelectorAll(".cart-drawer-quantity-selector button")
        .forEach((button) => {
            button.addEventListener("click", async () => {
                // Get line item key
                const rootItem = button.closest("[data-line-item-key]");
                const key = rootItem.getAttribute("data-line-item-key");

                // Get new quantity
                const currentQuantity = Number(
                    button.parentElement.querySelector("input").value
                );
                const isUp = button.classList.contains(
                    "cart-drawer-quantity-selector-plus"
                );
                const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

                // Ajax update
                const res = await fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ updates: { [key]: newQuantity } }),
                });

                const cart = await res.json();
                updateCartItemCounts(cart.item_count);
                updateCartDrawer();
            });
        });

    // **Fix: Handle remove button clicks with AJAX**
    document.querySelectorAll(".cart-drawer-remove").forEach((button) => {
        button.addEventListener("click", (event) => {
            event.preventDefault(); // Prevents redirect to /cart
            event.stopPropagation(); // Stops event bubbling

            const key = button.getAttribute("data-line-item-key");
            deleteCartItem(key);
        });
    });

    document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
        e.stopPropagation();
    });

    document
        .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
        .forEach((el) => {
            el.addEventListener("click", () => {
                closeCartDrawer();
            });
        });
}

addCartDrawerListeners();

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
        e.preventDefault();

        // Get the add to cart button
        const addToCartButton = form.querySelector(".product-add");
        const originalText = addToCartButton.innerHTML;

        // Show loader animation
        addToCartButton.innerHTML = `<span class="loader"></span> Adding...`;
        addToCartButton.disabled = true;

        // Submit form with ajax
        await fetch("/cart/add", {
            method: "post",
            body: new FormData(form),
        });

        // Get cart count
        const res = await fetch("/cart.js");
        const cart = await res.json();
        updateCartItemCounts(cart.item_count);

        // Update cart
        await updateCartDrawer();

        // Restore original button text
        addToCartButton.innerHTML = originalText;
        addToCartButton.disabled = false;

        // Open cart drawer
        openCartDrawer();
    });
});

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
    a.addEventListener("click", (e) => {
        e.preventDefault();
        openCartDrawer();
    });
});